import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import EmailRecipientTypes = Boo.Objects.Enums.EmailRecipientTypes;

@Component({
  selector: 'app-components-sales-customer-user-form',
  templateUrl: './customer-user-form.component.html'
})
export class CustomerUserFormComponent implements OnInit {
  @Input() contactForm: FormGroup;
  @Input() allowTextMessages = false;
  @Input() isNew: boolean;
  emailRecipientOptions = [
    EmailRecipientTypes.To,
    EmailRecipientTypes.Cc,
    EmailRecipientTypes.Bcc
  ];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.contactForm.get('emailRecipientType').setValue(EmailRecipientTypes.To);
  }
}
